<div class="paginator">
    <div class="icons-numbers">
        <fa-icon [icon]="faAngleLeft" (click)="previousPage()" *ngIf="getPageNumbers().length > 1"></fa-icon>
        <button *ngFor="let pageNumber of getPageNumbers()" class="page"
            [ngClass]="{ 'selected-page': pageNumber === (pageIndex + 1).toString(), 'page-number': pageNumber !== '...'}"
            (click)="setPageIndex(+pageNumber - 1)">{{pageNumber}}</button>
        <fa-icon [icon]="faAngleRight" (click)="nextPage()" *ngIf="getPageNumbers().length > 1">next</fa-icon>
    </div>
</div>